<template>
  <main class="HomePage">
    <section class="HomePage__main">
      <div class="HomePage__main-section">
        <h1 class="HomePage__main-title">
          One Capsule<br/>One Button<br/>One Minute
        </h1>
        <h3 class="HomePage__main-subtitle">
          Our Partners use CAPSULAB's <span class="bold">Factory in a Capsule</span> technology to change their consumers’ experience at its core.
        </h3>
        <div class="HomePage__main-text">
          CAPSULAB transforms the one-type-fits-all model
          into an always-personalized, always-fresh, on-demand process -creating better products for people and the planet
        </div>
        <router-link to="/use-cases/beauty-skincare" class="HomePage__main-learn">
          <span>
            Learn more
          </span>
        </router-link>
      </div>
      <div class="HomePage__main-logo">
        <img class="HomePage__main-capsule" src="/img/capsules/capsule-master-file.png">
        <img class="HomePage__main-figure" src="/img/background-shapes/elipse-pink.svg"/>
      </div>
    </section>
    <section class="HomePage__benefits">
      <div class="HomePage__benefits-item" style="margin-right: 20px">
<!--        <img class="HomePage__benefits-item&#45;&#45;logo" src="/img/background-shapes/logo-grey.svg"/>-->
        <h2 class="HomePage__benefits-item--title">Benefits For the Consumer</h2>
        <p class="HomePage__benefits-item--text">
          The product is created on the spot, in the capsule, based on the consumer’s specifications.
          This personalization and freshness mean a more efficacious product.
        </p>
        <p class="HomePage__benefits-item--text">
          This process creates significantly less waste and is much more sustainable and environmentally friendly.
        </p>
        <p class="HomePage__benefits-item--text">
          Also, CAPSULAB lets consumers use products that are preservative-free and with potent active ingredients.
        </p>
      </div>
      <div class="HomePage__benefits-item">
<!--        <img class="HomePage__benefits-item&#45;&#45;logo" src="/img/background-shapes/logo-grey.svg"/>-->
        <h2 class="HomePage__benefits-item--title">Benefits For Brands</h2>
        <p class="HomePage__benefits-item--text">
          The CAPSULAB technology moves the entire manufacturing process into the capsule,
          so there is no need for a manufacturing plant, only a filling plant.
        </p>
        <p class="HomePage__benefits-item--text">
          Providing a superior product at the same or lower cost: always personalized, always fresh.
        </p>
        <p class="HomePage__benefits-item--text">
          CAPSULAB also solves the issues brands have to maintain long term shelf life for products with natural ingredients.
        </p>
      </div>
    </section>
    <section class="HomePage__video">
      <div class="HomePage__video-info">
        <h2 class="HomePage__video-info--title">
          See CAPSULAB in Action
        </h2>
        <p class="HomePage__video-info--text">
          CAPSULAB is a category agnostic platform for home/professional devices and capsules that result in on-demand, fresh, personalized products.
        </p>
      </div>
      <div class="HomePage__video-element" :class="{'active': isVideoPlaying}">
        <span v-show="isVideoPlaying" class="HomePage__video-element-close" @click="closeVideo"></span>
        <div v-show="!isVideoPlaying" class="HomePage__video-overlay">
          <div class="HomePage__video-overlay--play" @click="playVideo">
            <font-awesome-icon :icon="['fas', 'play']"/>
            <div class="HomePage__video-overlay--circle" @click="playVideo"></div>
          </div>
        </div>
        <video ref="video" controls @play="isVideoPlaying=true" @ended="isVideoPlaying=false">
		<source src="/img/use-cases/full-capsulab.mp4"
                  type="video/mp4">
          Sorry, your browser doesn't support embedded videos.
        </video>
      </div>
      <img class="HomePage__video-figure" src="/img/background-shapes/capsule.svg"/>
    </section>
    <section id="technologies" class="HomePage__works">
      <div class="HomePage__works-item image">
        <img class="HomePage__works-capsule" src="/img/capsules/capsule.png">
        <img class="HomePage__works-figure" src="/img/background-shapes/elipse-pink.svg">
      </div>
      <div class="HomePage__works-item text">
        <h2 class="HomePage__works-title">
          How it works
        </h2>
        <p class="HomePage__works-text">
          The manufacturing is done within the capsule, by the consumer. Small and easily integrated into any environment,
          CAPSULAB provides the ideal customer experience.
        </p>
        <p class="HomePage__works-text">
          With six patents filed, CAPSULAB’s technology enables the @HOME manufacture of a wide range of products; cosmetics, supplements,
          food, and pharma - all in a personalized, fresh, clean, and sustainable manner.
        </p>
      </div>
    </section>
    <section class="HomePage__benefits2">
      <h2 class="HomePage__benefits2-title">Benefits</h2>
      <p class="HomePage__benefits2-text">
        CAPSULAB operates on a B2B model, licensing its technology to brand partners, creating enormous advantages for them in the market:
      </p>
      <div class="HomePage__benefits2-container">
        <benefit v-for="(item, index) in benefits" :key="index" :title="item.title" :text="item.text" :img="item.image"/>
        <img class="HomePage__benefits2-figure" src="/img/background-shapes/capsule.svg">
      </div>
    </section>
    <section class="HomePage__joinus">
      <h2 class="HomePage__joinus-title">Join the At-HOME Manufacturing Revolution</h2>
      <talk-to-us-button />
      <img class="HomePage__joinus-figure" src="/img/background-shapes/logo-grey.svg" />
    </section>
  </main>
</template>
<script>
import { BENEFITS } from "../assets/benefits";
import Benefits from "../components/items/Benefits";
export default {
  name: 'HomePage',
  components: {
    'benefit': Benefits
  },
  data: () => ({
    isVideoPlaying: false,
    benefits: BENEFITS
  }),
  mounted() {
    let section=this.$router.currentRoute.hash.replace("#", "");
    if (section)
      this.$nextTick(()=> window.document.getElementById(section).scrollIntoView());
  },
  methods: {
    playVideo() {
      this.$refs.video.play()
    },
    closeVideo() {
      this.$refs.video.pause()
      this.$refs.video.currentTime = 0
      this.isVideoPlaying = false
    }
  }
}
</script>
<style lang="scss">
.HomePage {
  @include content;
  margin: 0 1%;
  &__main {
    margin: 120px 2% 150px;
    display: grid;
    grid-template-columns: 50% 50%;
    &-title {
      @include title;
    }
    &-subtitle {
      @include subtitle;
    }
    &-text {
      font-size: 20px;
      line-height: 150%;
      margin: 20px 0 40px;
      @media screen and (max-width: 1090px) {
        font-size: 16px;
      }
    }
    &-learn {
      @include button
    }
    &-logo {
      position: relative;
      @media screen and (max-width: 775px) {
        text-align: center;
      }
    }
    &-capsule {
      max-width: 536px;
      width: 100%;
      align-items: center;
      @media screen and (max-width: 775px) {
        max-width: 375px;
      }
    }
    &-figure {
      max-width: 596px;
      width: 100%;
      position: absolute;
      top: 10%;
      left: 9%;
      z-index: -1;
      @media screen and (max-width: 775px){
        max-width: 400px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    @media screen and (max-width: 775px) {
      grid-template-columns: 1fr;
      grid-template-rows: auto auto;
      grid-row-gap: 40px;
      margin-bottom: 90px;
    }
  }
  &__benefits {
    display: flex;
    justify-content: space-between;
    margin-bottom: 200px;
    &-item {
      margin: 15px 0;
      padding: 40px;
      max-width: 565px;
      background: #FFFFFF;
      border: 1px solid #F2F2F2;
      box-sizing: border-box;
      box-shadow: 0 15px 30px -10px rgba(21, 17, 71, 0.09);
      border-radius: 24px;
      color: $color;
      &--logo {
        width: 130px;
        margin-bottom: 15px;
      }
      &--title {
        font-weight: bold;
        font-size: 36px;
        margin-bottom: 24px;
      }
      &--text {
        font-size: 18px;
        margin-bottom: 20px;
        line-height: 150%;
      }
      @media screen and (max-width: 940px) {
        margin: 15px 0!important;
      }
    }
    @media screen and (max-width: 940px) {
      flex-direction: column;
      align-items: center;
      margin-bottom: 70px;
    }
  }
  &__video {
    display: flex;
    margin-bottom: 460px;
    align-items: center;
    position: relative;
    &-info {
      &--title {
        @include title;
        text-transform: none;
        margin-right: 40px;
        color: #FFFFFF;
      }
      &--text {
        font-size: 20px;
        line-height: 150%;
        color: #FFFFFF;
        width: 85%;
        margin-bottom: 40px;
        margin-top: 20px;
        @media screen and (max-width: 1090px) {
          font-size: 18px;
        }
      }
    }
    &-element {
      position: relative;
      width: 100%;
      max-width: 565px;
      transition: 3ms ease-in-out;
      &-close {
        position: absolute;
        z-index: 9999999;
        top: 2%;
        right: 2%;
        width: 32px;
        height: 32px;
        opacity: 0.7;
        &:hover {
          opacity: 1;
          cursor: pointer;
        }
        &:before, &:after {
          position: absolute;
          left: 15px;
          content: ' ';
          height: 33px;
          width: 2px;
          background-color: #FFFFFF;
        }
        &:before {
          transform: rotate(45deg);
        }
        &:after {
          transform: rotate(-45deg);
        }
      }
      video {
        width: 100%;
        height: 344px;
        background: #080712;
        border-radius: 24px;
      }
      &.active {
        position: fixed;
        display: flex;
        z-index: 9999;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        max-width: none;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,.7);
        video {
          width: 90%;
          height: auto;
          max-height: 90%;
          z-index: 9999;
        }
        &>.HomePage__video-overlay {
          display: none;
        }
      }
    }
    &-overlay {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 101%;
      height: 100%;
      z-index: 1;
      border-radius: 24px;
      background-image: url("/img/video-overlay.png");
      background-size: cover;
      background-position: center;
      box-shadow: 0 15px 31px -10px rgba(21, 17, 71, 0.09);
      &--play {
        border-radius: 50px;
        width: 86px;
        height: 86px;
        background: #FCE0DA;
        padding: 28px 32px;
        position: relative;
        transition: all .3s ease 0ms;
        svg {
          font-size: 32px;
        }
        &:hover {
          cursor: pointer;
          transform: scale(1.1);
        }
      }
      &--circle {
        border: solid 1px #FCE0DA;
        border-radius: 100%;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 10;
        -webkit-animation: pulse 2s ease-out;
        -moz-animation: pulse 2s ease-out;
        animation: pulse 2s ease-out;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
        &:hover {
          cursor: pointer;
        }
      }
    }
    &-figure {
      width: 2600px;
      top: -110%;
      position: absolute;
      z-index: -1;
      right: 119%;
      transform: translateX(50%) rotate(-15deg);
      @media screen and (max-width: 1020px) {
        top: -90%;
        right: 128%;
      }
      @media screen and (max-width: 775px) {
        top: -43%;
        width: 2097px;
        right: 147%;
        transform: translateX(50%) rotate(-9deg);
      }
    }
    @media screen and (max-width: 1020px) {
      flex-direction: column;
      align-items: flex-start;
    }
    @media screen and (max-width: 1020px) {
      margin-bottom: 200px;
    }
  }
  &__works {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
    align-items: center;
    margin-bottom: 200px;
    &-item {
      position: relative;
      &.image {
        @media screen and (max-width: 775px) {
          text-align: center;
        }
      }
      &.text {
        margin-top: 70px;
        @media screen and (max-width: 775px) {
          margin-top: 0;
        }
      }
    }
    &-title {
      margin-bottom: 35px;
      @include title;
      font-size: 64px;
      text-transform: none;
      @media screen and (max-width: 775px) {
        margin-bottom: 15px;
      }
    }
    &-text {
      font-size: 20px;
      line-height: 150%;
      margin-bottom: 15px;
      @media screen and (max-width: 1090px) {
        font-size: 18px;
      }
    }
    &-capsule {
      max-width: 536px;
      width: 100%;
      @media screen and (max-width: 775px) {
        max-width: 375px;
      }
    }
    &-figure {
      max-width: 565px;
      width: 85%;
      left: 20px;
      top: 35px;
      z-index: -1;
      position: absolute;
      @media screen and (max-width: 775px) {
        max-width: 350px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    @media screen and (max-width: 775px) {
      grid-template-columns: 1fr;
      grid-template-rows: auto auto;
      grid-row-gap: 20px;
      margin-bottom: 50px;
    }
  }
  &__benefits2 {
    color: $color;
    margin-bottom: 200px;
    &-title {
      font-weight: bold;
      font-size: 64px;
      line-height: 110%;
      margin-bottom: 30px;
      @media screen and (max-width: 1090px) {
        font-size: 42px;
      }
      @media screen and (max-width: 775px) {
        margin-bottom: 15px;
      }
    }
    &-text {
      font-size: 20px;
      line-height: 150%;
      margin-right: 53%;
      @media screen and (max-width: 1090px) {
        font-size: 18px;
      }
      @media screen and (max-width: 775px) {
        width: 100%;
      }
    }
    &-container {
      margin-top: 50px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      position: relative;
    }
    &-figure {
      position: absolute;
      top: 190px;
      right: -800px;
      width: 1650px;
      z-index: -1;
      transform: rotate(81deg);
      @media screen and (max-width: 775px) {
        right: -950px;
      }
    }
    @media screen and (max-width: 775px) {
      margin-bottom: 50px;
    }
  }
  &__joinus {
    position: relative;
    color: $color;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: 350px 0 100px;
    &-title {
      @include joinus-title;
    }
    &-figure {
      position: absolute;
      z-index: -1;
    }
    @media screen and (max-width: 1172px){
      margin: 0 0 60px 0;
    }
  }
  @media screen and (max-width: 775px){
    padding: 0 3%;
  }
}
@-moz-keyframes pulse {
  0% {
    -moz-transform: scale(1);
    opacity: 0.0;
  }
  25% {
    -moz-transform: scale(1.25);
    opacity: 0.1;
  }
  50% {
    -moz-transform: scale(1.5);
    opacity: 0.3;
  }
  75% {
    -moz-transform: scale(1.75);
    opacity: 0.5;
  }
  100% {
    -moz-transform: scale(2);
    opacity: 0.0;
  }
}

@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale(1);
    opacity: 0.0;
  }
  1% {
    -webkit-transform: scale(1.1);
    opacity: 0.9;
  }
  99% {
    -webkit-transform: scale(1.9);
    opacity: 0.01;
  }
  100% {
    -webkit-transform: scale(2);
    opacity: 0.0;
  }
}
</style>
